import { SITE_MAP } from 'globalConstants';
import {
  LIKE_COMMENT,
  LikeCommentData,
  LikeCommentVariables,
} from 'graphql/main/mutations/temp/like-comment';
import { Comment } from 'graphql/main/queries/temp/comments';
import { useFlexMutation } from 'hooks';
import { gt, isNumber } from 'lodash';
import moment from 'moment-timezone';
import 'moment/min/locales';
import Link from 'next/link';
import { MouseEvent } from 'react';
import { timeSince } from 'utils';

interface Props {
  comment?: Comment;
  onReply?: () => void;
}
const CommentNode = ({ comment, onReply }: Props) => {
  const [likeComment] = useFlexMutation<LikeCommentData, LikeCommentVariables>(
    'main',
    LIKE_COMMENT,
  );

  const like = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (comment?.id) {
      const { errors: likeCommentErrors } = await likeComment({
        variables: { commentId: comment.id },
      });
      if (!likeCommentErrors) {
        comment.countLike = comment.isLiked
          ? isNumber(comment.countLike)
            ? comment.countLike - 1
            : 0
          : isNumber(comment.countLike)
          ? comment.countLike + 1
          : 0;
        comment.isLiked = !comment.isLiked;
      }
    }
  };

  return (
    <div className='flex w-full space-x-[12px]'>
      <Link
        href={`/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.SOCIAL_PROFILE}/${comment?.owner?.id}`}
      >
        <div className='h-[36px] w-[36px] cursor-pointer overflow-hidden rounded-full'>
          <img
            src={comment?.owner?.avatar?.originalUrl ?? '/images/default-avatar.svg'}
            alt={comment?.owner?.fullName}
            loading='lazy'
            className='h-full w-full object-cover'
          />
        </div>
      </Link>
      <div className='flex flex-col w-full space-y-[8px]'>
        <div className='flex flex-col w-full rounded-[8px] space-y-[10px] bg-secondary px-[12px] py-[8px]'>
          <Link
            href={`/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.SOCIAL_PROFILE}/${comment?.owner?.id}`}
            className='font-[600] hover:underline'
          >
            {comment?.owner?.fullName}
          </Link>
          <span>{comment?.body}</span>
        </div>
        <div className='flex space-x-[16px] pl-[16px] text-[12px] leading-[15px] text-text2'>
          <button
            type='button'
            className={`font-[600] hover:underline ${
              comment?.isLiked ? 'text-[#ff4f66] decoration-[#ff4f66]' : ''
            }`}
            onClick={like}
          >
            <span>{gt(comment?.countLike, 0) ? comment?.countLike : ''} Thích</span>
          </button>
          <button type='button' className='font-[600] hover:underline' onClick={onReply}>
            <span>Trả lời</span>
          </button>
          <span>{timeSince(moment(comment?.createdAt).toDate())}</span>
        </div>
      </div>
    </div>
  );
};

export default CommentNode;
